import { useIntl } from 'react-intl'
import { getPlural } from 'lib/string/pluralize'

// TODO: i18n - Category B (complex pricing format). HIGHLIGHT_MESSAGE_UNAVAILABLE_FOR_DATES uses getPlural
// with a dynamic saleUnit from the API. Needs backend coordination to localise.

export function HIGHLIGHT_MESSAGE_UNAVAILABLE_FOR_DATES(saleUnit: string) {
  return `There are no ${getPlural(saleUnit)} available for your selected dates.`
}

export function useHighlightMessages() {
  const intl = useIntl()

  const highlightMessageAvailableForDates = intl.formatMessage({
    id: 'ojRHOgxIYT',
    defaultMessage: 'We found a limited time deal for your hotel. Choose dates and book now before it ends!',
    description: 'Highlight banner message when a limited time deal is available for selected dates',
  })

  const highlightMessageStayMinNights = (minNumNights: number) => intl.formatMessage(
    {
      id: 'lPbRpiYz+n',
      defaultMessage: 'Stay for at least {minNumNights, plural, one {# night} other {# nights}} to enjoy this special offer',
      description: 'Highlight banner message indicating minimum nights required for a special offer',
    },
    { minNumNights },
  )

  const unavailableBannerMessageStayMinNights = (minNumNights: number) => intl.formatMessage(
    {
      id: 'FRjZTVd0n4',
      defaultMessage: 'Stay for at least {minNumNights, plural, one {# night} other {# nights}} to unlock this offer',
      description: 'Unavailability banner message indicating minimum nights required to unlock an offer',
    },
    { minNumNights },
  )

  return {
    highlightMessageAvailableForDates,
    highlightMessageStayMinNights,
    unavailableBannerMessageStayMinNights,
  }
}
